import React from 'react'
import { NavLink } from 'react-router-dom'
import { useState } from 'react'
import '../../App.css'
// import
// import '../../../node_modules/font-awesome/css/font-awesome.min.css'

const Login = () => {

    // function LoginForm() {
  const [rememberMe, setRememberMe] = useState(false);

  const handleCheckboxChange = () => {
    setRememberMe(!rememberMe);
  };

  return (
    <>
    <div className="container">
    <div className="row">
    <div className="col-md-2"></div>
    <div className="col-md-8">

    <section className='class="p-2 text-center mb-4 w-100"'>
        <div className="container d-flex flex-column w-50 my-5">
          {/* <!-- Pills navs --> */}

          <ul
            className="nav nav-pills nav-justified mb-3"
            id="ex1"
            role="tablist"
          >
            <li className="nav-item log-sign" role="presentation">
              <NavLink
                className="nav-link active"
                id="tab-login"
                data-mdb-toggle="pill"
                to="#pills-login"
                role="tab"
                aria-controls="pills-login"
                aria-selected="true"
              >
                Login
              </NavLink>
            </li>

            <li className="nav-item log-sign" role="presentation">
              <NavLink
                className="nav-link"
                id="tab-register"
                data-mdb-toggle="pill"
                to="#pills-register"
                role="tab"
                aria-controls="pills-register"
                aria-selected="false"
                tabindex="-1"
              >
                Register
              </NavLink>
            </li>
          </ul>

          {/* <!-- Pills navs --> */}

          {/* <!-- Pills content --> */}
          <div className="tab-content">
            <div
              className="tab-pane fade show active"
              id="pills-login"
              role="tabpanel"
              aria-labelledby="tab-login"
            >
              <form>
                <div className="text-center mb-3">
                  <p>Sign in with:</p>
                  <button
                    type="button"
                    className="btn btn-link btn-floating mx-1"
                  >
                    <i className="fa fa-facebook-f"></i>
                  </button>

                  <button
                    type="button"
                    className="btn btn-link btn-floating mx-1"
                  >
                    <i className="fa fa-google"></i>
                  </button>

                  <button
                    type="button"
                    className="btn btn-link btn-floating mx-1"
                  >
                    <i className="fa fa-twitter"></i>
                  </button>

                  <button
                    type="button"
                    className="btn btn-link btn-floating mx-1"
                  >
                    <i className="fa fa-github"></i>
                  </button>
                </div>

                <p className="text-center">or:</p>

                {/* <!-- Email input --> */}
                <div className="form-outline mb-4">
                  <input type="email" id="loginName" className="form-control" />
                  <label
                    className="form-label"
                    htmlFor="loginName"
                    style={{ marginleft: '0px' }}
                  >
                    Email or username
                  </label>
                  <div className="form-notch">
                    <div
                      className="form-notch-leading"
                      style={{ width: '9px' }}
                    ></div>
                    <div
                      className="form-notch-middle"
                      style={{ width: '115.2px' }}
                    ></div>
                    <div className="form-notch-trailing"></div>
                  </div>
                </div>

                {/* <!-- Password input --> */}
                <div className="form-outline mb-4">
                  <input
                    type="password"
                    id="loginPassword"
                    className="form-control"
                  />
                  <label
                    className="form-label"
                    htmlFor="loginPassword"
                    style={{ marginleft: '0px' }}
                  >
                    Password
                  </label>
                  <div className="form-notch">
                    <div
                      className="form-notch-leading"
                      style={{ width: '9px' }}
                    ></div>
                    <div
                      className="form-notch-middle"
                      style={{ width: '64px' }}
                    ></div>
                    <div className="form-notch-trailing"></div>
                  </div>
                </div>

                {/* <!-- 2 column grid layout --> */}
                <div className="row mb-4">
                  <div className="col-md-6 d-flex justify-content-center">
                    {/* <!-- Checkbox --> */}
                    <div className="form-check mb-3 mb-md-0">
        <input
          className="form-check-input"
          type="checkbox"
          value=""
          id="loginCheck"
          checked={rememberMe}
          onChange={handleCheckboxChange}
        />
        <label className="form-check-label" htmlFor="loginCheck">
          {' '}
          Remember me{' '}
        </label>
      </div>
                  </div>

                  <div className="col-md-6 d-flex justify-content-center">
                    {/* <!-- Simple link --> */}
                    <NavLink to="#!">Forgot password?</NavLink>
                  </div>
                </div>

                {/* <!-- Submit button --> */}
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4"
                >
                  Sign in
                </button>

                {/* <!-- Register buttons --> */}
                <div className="text-center">
                  <p>
                    Not a member? <NavLink to="/Register">Register</NavLink>
                  </p>
                </div>
              </form>
            </div>
            <div
              className="tab-pane fade"
              id="pills-register"
              role="tabpanel"
              aria-labelledby="tab-register"
            >
              <form>
                <div className="text-center mb-3">
                  <p>Sign up with:</p>
                  <button
                    type="button"
                    className="btn btn-link btn-floating mx-1"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </button>

                  <button
                    type="button"
                    className="btn btn-link btn-floating mx-1"
                  >
                    <i className="fab fa-google"></i>
                  </button>

                  <button
                    type="button"
                    className="btn btn-link btn-floating mx-1"
                  >
                    <i className="fab fa-twitter"></i>
                  </button>

                  <button
                    type="button"
                    className="btn btn-link btn-floating mx-1"
                  >
                    <i className="fab fa-github"></i>
                  </button>
                </div>

                <p className="text-center">or:</p>

                {/* <!-- Name input --> */}
                <div className="form-outline mb-4">
                  <input
                    type="text"
                    id="registerName"
                    className="form-control"
                  />
                  <label
                    className="form-label"
                    htmlFor="registerName"
                    style={{ marginleft: '0px' }}
                  >
                    Name
                  </label>
                  <div className="form-notch">
                    <div
                      className="form-notch-leading"
                      style={{ width: '9px' }}
                    ></div>
                    <div
                      className="form-notch-middle"
                      style={{ width: '8px' }}
                    ></div>
                    <div className="form-notch-trailing"></div>
                  </div>
                </div>

                {/* <!-- Username input --> */}
                <div className="form-outline mb-4">
                  <input
                    type="text"
                    id="registerUsername"
                    className="form-control"
                  />
                  <label
                    className="form-label"
                    htmlFor="registerUsername"
                    style={{ marginleft: '0px' }}
                  >
                    Username
                  </label>
                  <div className="form-notch">
                    <div
                      className="form-notch-leading"
                      style={{ width: '9px' }}
                    ></div>
                    <div
                      className="form-notch-middle"
                      style={{ width: '8px' }}
                    ></div>
                    <div className="form-notch-trailing"></div>
                  </div>
                </div>

                {/* <!-- Email input --> */}
                <div className="form-outline mb-4">
                  <input
                    type="email"
                    id="registerEmail"
                    className="form-control"
                  />
                  <label
                    className="form-label"
                    htmlFor="registerEmail"
                    style={{ marginleft: '0px' }}
                  >
                    Email
                  </label>
                  <div className="form-notch">
                    <div
                      className="form-notch-leading"
                      style={{ width: '9px' }}
                    ></div>
                    <div
                      className="form-notch-middle"
                      style={{ width: '8px' }}
                    ></div>
                    <div className="form-notch-trailing"></div>
                  </div>
                </div>

                {/* <!-- Password input --> */}
                <div className="form-outline mb-4">
                  <input
                    type="password"
                    id="registerPassword"
                    className="form-control"
                  />
                  <label
                    className="form-label"
                    htmlFor="registerPassword"
                    style={{ marginleft: '0px' }}
                  >
                    Password
                  </label>
                  <div className="form-notch">
                    <div
                      className="form-notch-leading"
                      style={{ width: '9px' }}
                    ></div>
                    <div
                      className="form-notch-middle"
                      style={{ width: '8px' }}
                    ></div>
                    <div className="form-notch-trailing"></div>
                  </div>
                </div>

                {/* <!-- Repeat Password input --> */}
                <div className="form-outline mb-4">
                  <input
                    type="password"
                    id="registerRepeatPassword"
                    className="form-control"
                  />
                  <label
                    className="form-label ml-0"
                    htmlFor="registerRepeatPassword"
                  >
                    Repeat password
                  </label>
                  <div className="form-notch">
                    <div
                      className="form-notch-leading w-9"
                      style={{ width: '9px' }}
                    ></div>
                    <div
                      className="form-notch-middle"
                      style={{ width: '8px' }}
                    ></div>
                    <div className="form-notch-trailing"></div>
                  </div>
                </div>

                {/* <!-- Checkbox --> */}
                <div className="form-check d-flex justify-content-center mb-4">
                  <input
                    className="form-check-input me-2"
                    type="checkbox"
                    value=""
                    id="registerCheck"
                    checked=""
                    aria-describedby="registerCheckHelpText"
                  />
                  <label className="form-check-label" htmlFor="registerCheck">
                    I have read and agree to the terms
                  </label>
                </div>

                {/* <!-- Submit button --> */}
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-3"
                >
                  Sign in
                </button>
              </form>
            </div>
          </div>
          {/* <!-- Pills content --> */}
        </div>
      </section>


    </div>
      <div className="col-md-2"></div>


    </div>


    </div>
      
    </>
  )
}

export default Login
